var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "bg-gray2" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "d-block d-sm-none py-2 mb-3 mt-2" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [_c("skeleton-mobile-views-history-card")],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-none d-sm-block d-lg-none py-2 mb-3 mt-2" },
          [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-6" },
                [_c("skeleton-mobile-views-history-card")],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6" },
                [_c("skeleton-mobile-views-history-card")],
                1
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-none d-lg-block py-2 mb-3 mt-2" }, [
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(4, function (x) {
              return _c(
                "div",
                { key: "reco" + x, staticClass: "col-3" },
                [_c("skeleton-mobile-views-history-card")],
                1
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.withSubtitle
      ? _c("div", { staticClass: "container-fluid" }, [_vm._m(3)])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ob1-skeleton" }, [
      _c("div", {
        staticClass: "ob1-skeleton-gray2 mt-1 mb-2",
        staticStyle: { width: "300px", height: "30px" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ob1-skeleton" }, [
      _c("div", {
        staticClass: "ob1-skeleton-gray2 mt-1 mb-2",
        staticStyle: { width: "300px", height: "30px" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ob1-skeleton" }, [
      _c("div", {
        staticClass: "ob1-skeleton-gray2 mt-1 mb-2",
        staticStyle: { width: "500px", height: "30px" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ob1-skeleton" }, [
      _c("div", {
        staticClass: "ob1-skeleton-white px-2 mt-2 mb-3",
        staticStyle: { width: "300px", height: "30px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }